import {MaxLengthTextValidator, MinLengthTextValidator} from './validator';

export {TextDirective} from './directive';
export {TextPipe} from './pipe';
export {ExtraTextControlValidators} from './validator';

export const TEXT_VALIDATORS = [MaxLengthTextValidator, MinLengthTextValidator];
